import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'polpo-legals-page-ai',
  templateUrl: './legals-page-ai.component.html',
})
export class LegalsPageAiComponent {}
